<template>
    <div>
        <div v-if="!printView">
        <b-overlay :show="status && (status.type === 'removed' || status.type === 'cancelled')" opacity="0.75" blur="0">
            <b-row>
                <b-col sm="2" v-if="!hideImages">
                    <div v-if="item.listing.images && item.listing.images.length" 
                         @click="handleImageClick" 
                         class="clickable-image-wrapper"
                         style="cursor: pointer; display: block; position: relative; z-index: 1000;">
                        <b-img fluid :src="imageSrc(item.listing.images)" />
                    </div>
                    <b-img v-else fluid></b-img>
                </b-col>
                <b-col sm="6">
                    <p class="mb-0"><strong>{{ artist(item) }}</strong></p>
                    <p class="mb-0"><strong>{{ title(item) }}</strong></p>
                    <p class="mb-0" v-if="item.release.label">{{ item.release.label.name }} {{ item.release.label.catalogNo }}</p>
                    <p class="mb-0">{{ format(item.release.media) }}</p>
                    <p class="mb-0"><em>{{ pressing(item).join(', ') }}</em></p>
                    <p class="mb-0"><em>{{ notes(item).join(', ') }}</em></p>
                </b-col>

                <b-col :sm="hideImages ? '6' : '4'">
                    <b-row>
                        <b-col sm="5">SKU</b-col>
                        <b-col>
                            <b-link @click="navigateToInventory(item.itemId)" style="cursor: pointer;">{{ item.itemId }}</b-link>
                        </b-col>
                    </b-row>
                    <div v-for="(c, index) in conditions(item.listing)" v-bind:key="'condition-' + index">
                        <b-row>
                            <b-col sm="5"><span>{{ c.subject }} Grade</span></b-col>
                            <b-col class="ml-auto">{{ c.grade }}</b-col>
                        </b-row>

                        <b-row v-if="c.notes">
                            <b-col>
                                <em>{{ c.notes }}</em>
                            </b-col>
                        </b-row>
                    </div>

                    <b-row>
                        <b-col sm="5">
                            <span>Price</span>
                        </b-col>

                        <b-col class="ml-auto">${{ item.listing.price }}</b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="5">
                            <span>Quantity</span>
                        </b-col>
                        
                        <b-col class="ml-auto"><em v-if="item.quantity > 1"><strong>{{ item.quantity }}</strong></em>
                        <span v-else>{{ item.quantity }}</span></b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="5">
                            <span>Location</span>
                        </b-col>

                        <b-col class="ml-auto">{{ item.listing.location ? item.listing.location.toUpperCase() : '' }}</b-col>
                    </b-row>
                </b-col>
            </b-row>
            
            <b-row v-if="showModifiedHistory && item.listing.username && item.listing.date">
                <b-col class="border-top mt-2 pt-2 align-flex-end">
                    entered by <strong>{{  item.listing.username }}</strong> on <strong>{{  moment(item.listing.date).format('M/D/YYYY') }}</strong> 
                </b-col>
            </b-row>

            <template #overlay>
                <div class="text-center" v-if="status.type === 'removed' || 'cancelled'">
                    <h6 class="mb-0"><span v-if="status.type ==='removed'">Removed</span> <span v-if="status.type ==='cancelled'">Order cancelled</span> {{ moment(status.date).format('M/D/YYYY h:mma') }} by {{ status.username }}</h6>
                    <em v-if="status.reason && status.type === 'removed'">{{ status.reason }}</em>
                    <p>{{ status.stockAffected ? 'Stock changed' : 'Stock did not change' }}</p>
                </div>
            </template>
        </b-overlay>
        </div>

        <div v-else>

            <b-row v-if="!status || Object.keys(status).length === 0 || (status.type && status.type !== 'removed')">
            
                <b-col sm="3">
                    <b-img fluid :src="imageSrc(item.listing.images)" />
                </b-col>
                <b-col>
                    <p class="mb-0"><strong>{{ artistPrint(item) }}</strong></p>
                    <p class="mb-0"><strong>{{ titlePrint(item) }}</strong></p>
                    <p class="mb-0" v-if="item.release.label">{{ item.release.label.name }} {{ item.release.label.catalogNo }}</p>
                    <p class="mb-0">{{ formatPrint(item.release.media) }}</p>
                    <p class="mb-0"><em>{{ pressingPrint(item).join(', ') }}</em></p>
                    <p class="mb-0"><em>{{ notesPrint(item).join(', ') }}</em></p>
                </b-col>

                <b-col>
                    <b-row>
                        <b-col sm="5">SKU</b-col>
                        <b-col>{{ item.itemId }}</b-col>
                    </b-row>

                    <div v-for="(c, index) in conditionsPrint(item.listing)" v-bind:key="'condition-' + index">
                        <b-row>
                            <b-col sm="5"><span>{{ c.subject }} Grade</span></b-col>
                            <b-col class="ml-auto">{{ c.grade }}</b-col>
                        </b-row>

                        <b-row v-if="c.notes">
                            <b-col>
                                <em>{{ c.notes }}</em>
                            </b-col>
                        </b-row>
                    </div>

                    <b-row>
                        <b-col sm="5">
                            <span>Price</span>
                        </b-col>

                        <b-col class="ml-auto">${{ item.listing.price }}</b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="5">
                            <span>Quantity</span>
                        </b-col>

                        <b-col class="ml-auto"><em v-if="item.quantity > 1"><strong>{{ item.quantity }}</strong></em>
                        <span v-else>{{ item.quantity }}</span></b-col>                    </b-row>

                    <b-row>
                        <b-col sm="5">
                            <span>Location</span>
                        </b-col>

                        <b-col class="ml-auto">
                            {{ item.listing.location ? item.listing.location.toUpperCase() : '' }}
                            <p v-if="this.inventoryItem && this.inventoryItem.listing && pullText.length" class="mb-0 mt-1">
                                ({{ pullText.join(', ') }})
                            </p>
                        </b-col>
                    </b-row>

                    <b-row v-if="showSource && item.listing.source.length">
                        <b-col sm="5">
                            <span>Source</span>
                        </b-col>

                        <b-col class="ml-auto">{{ item.listing.source }}</b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
        
        <b-modal v-if="!printView && item.listing.images && item.listing.images.length" 
                 centered
                 size="lg"
                 :id="'itemImageModal-' + item.itemId"
                 hide-footer
                 hide-header
                 v-model="showImageModal">
            <div v-if="modalImages && modalImages.length">
                <b-row>
                    <b-col sm="9">
                        <div style="position: relative; min-height: 400px; display: flex; align-items: center; justify-content: center;">
                            <b-spinner v-if="imageLoading" 
                                      variant="primary"
                                      style="position: absolute; z-index: 10;">
                            </b-spinner>
                            <b-img :src="currentImageUrl"
                                   @click="openImageInNewWindow(currentImageUrl)"
                                   @load="imageLoading = false"
                                   @loadstart="imageLoading = true"
                                   class="order-item-image-main"
                                   :class="{ 'opacity-50': imageLoading }"
                                   :style="{ visibility: imageLoading ? 'hidden' : 'visible' }"
                                   fluid>
                            </b-img>
                        </div>
                    </b-col>
                    <b-col align="center">
                        <b-link v-for="(img, index) in modalImages"
                                @click="viewImage(index)"
                                :key="index">
                            <b-img width="125px;"
                                   class="mr-2"
                                   thumbnail
                                   block
                                   :src="getImageUrl(img)">
                            </b-img>
                        </b-link>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import OrderItemMixin from "../../builders/orderItem";
    import printItemMixin from "../../builders/printItem";
    import inventoryApi from "../../api/inventory";

    export default {
        name: "Item",
        props: [ 'item', 'printView', 'hideImages', 'showSource', 'status', 'showModifiedHistory' ],
        mixins: [ OrderItemMixin, printItemMixin, inventoryApi ],
        data() {
            return {
                inventoryItem: {},
                showImageModal: false,
                modalImages: [],
                currentImageIndex: 0,
                imageLoading: false,
            }
        },
        async created() {
            if (this.printView) {
                if (this.item.currentItem) {
                    // if the items have been enriched we can use the current item
                    this.inventoryItem = this.item.currentItem;
                } else {
                    // otherwise we need the item to show active / inactive / recent
                    this.inventoryItem = await this.getItem(this.item.itemId);
                }
            }
        },
        methods: {
            imageSrc(images) {
                if (!images.length) {
                    return ``;
                }

                const imageRequest = JSON.stringify({
                    bucket: 'record-photos',
                    key: this.item.listing.images[0].url,
                    edits: { resize: { width: 300 } },
                });

                return `${process.env.VUE_APP_THUMBNAIL_PATH}/${btoa(imageRequest)}`;

                // return `${process.env.VUE_APP_IMAGES_URL}${images[0].url}`;
            },
            handleImageClick(event) {
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                if (this.item && this.item.listing && this.item.listing.images && this.item.listing.images.length > 0) {
                    this.modalImages = this.item.listing.images;
                    this.currentImageIndex = 0;
                    this.imageLoading = true; // Show loading when opening modal
                    this.showImageModal = true;
                    this.$nextTick(() => {
                        this.$bvModal.show('itemImageModal-' + this.item.itemId);
                    });
                }
            },
            getImageUrl(img) {
                return process.env.VUE_APP_IMAGES_URL + img.url;
            },
            viewImage(index) {
                this.imageLoading = true;
                this.currentImageIndex = index;
            },
            openImageInNewWindow(imageUrl) {
                // Open in new tab - if server sends Content-Disposition: attachment, it will download
                // The tab will close automatically when download starts
                window.open(imageUrl, 'imageViewer');
            },
            navigateToInventory(itemId) {
                const query = { 
                    itemIds: itemId.toString()
                };
                this.$router.push({ name: 'inventory', params: { outsideQuery: { filters: query, itemId: itemId.toString() } } });
            }
        },
        computed: {
            currentImageUrl() {
                if (this.modalImages && this.modalImages.length > 0 && this.modalImages[this.currentImageIndex]) {
                    return this.getImageUrl(this.modalImages[this.currentImageIndex]);
                }
                return '';
            },
            isRecent() {
                return this.isItemRecentPrint(this.item);
            },
            hasInactive() {
                return this.noActiveHasInactivePrint(this.inventoryItem, this.item.listing.location);
            },
            hasMoreQuantity() {
                return this.hasMoreActivePrint(this.inventoryItem, this.item.listing.location);
            },
            pullText() {
                let texts = [];

                if (this.isRecent) {
                    texts.push('Recent');
                }

                if (this.hasInactive) {
                    texts.push('Inactive');
                }

                if (this.hasMoreQuantity) {
                    texts.push('Active');
                }

                return texts;
            }
        }
    }
</script>

<style scoped>
    span {
        color: grey;
    }
    .clickable-image-wrapper {
        cursor: pointer;
    }
    .clickable-image-wrapper:hover img {
        opacity: 0.8;
    }
    .order-item-image-main {
        cursor: pointer;
    }
</style>